module.exports = __webpack_public_path__ + "img/bass-guitar-body.ec8a0d89.jpg";